// Create trim objects with unique id's using trimId-engineType-bodyStyle-driveType
// a model can have trims with differing engines, bodies, drive types and doors
export default function getBapTrimId(item) { return `${item.trimId}-${item.engineType}-${item.bodyStyle}`; }
